import Vue from "vue"
import { get } from "@/lodash"

Vue.mixin({
  computed: {
    profile() {
      return this.$store.state.auth.profile
    },
  },
  methods: {
    /**
     * We use `get` from `lodash` to safely retrieve data from properties which
     * might not exist.
     * For example, in Show/Form.vue, we use it to retrieve nested error
     * messages.
     */
    get,
  },
})
